/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same RPM, larger radius → higher g-force.`)
};

const es_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mismas RPM, mayor radio → mayor fuerza g.`)
};

const de_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleiche Drehzahl, größerer Radius → höhere G-Kraft.`)
};

const nl_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zelfde RPM, grotere straal → hogere g-kracht.`)
};

const fr_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À vitesse égale, un rayon plus grand donne une force g plus élevée.`)
};

const it_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stessi RPM, raggio maggiore → forza G più alta.`)
};

const pt_br2_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesma RPM, raio maior → maior força g.`)
};

const pt_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesma RPM, raio maior → força g mais elevada.`)
};

const ja_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同じRPMでも、半径が大きいほどg力は高くなります。`)
};

const zh_gf_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相同转速下，半径越大，离心力越高。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_ex3", locale)
	if (locale === "en") return en_gf_ex3(inputs)
	if (locale === "es") return es_gf_ex3(inputs)
	if (locale === "de") return de_gf_ex3(inputs)
	if (locale === "nl") return nl_gf_ex3(inputs)
	if (locale === "fr") return fr_gf_ex3(inputs)
	if (locale === "it") return it_gf_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_gf_ex3(inputs)
	if (locale === "pt") return pt_gf_ex3(inputs)
	if (locale === "ja") return ja_gf_ex3(inputs)
	return zh_gf_ex3(inputs)
};